import { Component, OnInit } from '@angular/core';
import { LiveUpdateService } from '../shared/live-update.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ae-cms-login',
  templateUrl: './cms-login.component.html',
  styles: []
})
export class CmsLoginComponent implements OnInit {

  public email: string;
  public pass: string;

  constructor(private liveUpdateService: LiveUpdateService, private route: Router) { }

  ngOnInit() {
  }

  signIn() {
    this.liveUpdateService.signIn(this.email, this.pass).then(() => {
      this.route.navigate(['../cms-campaign']);
    });
  }
}
